import { root } from 'app/store/constants';
import { firstBoardLoadAndSave } from 'app/rest/effects/firstBoard/firstBoardLoadAndSave';
import {
    AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID, BLANK_TEMPLATE_BOARD_ID,
    BUSINESS_CANVAS_TEMPLATE_BOARD_ID,
    CLASSIC_KANBAN_TEMPLATE_BOARD_ID,
    CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID,
    CLASSROOM_WORK_TEMPLATE_BOARD_ID,
    COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID,
    CONTENT_CREATION_TEMPLATE_BOARD_ID,
    CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID,
    DESIGN_PROCESS_TEMPLATE_BOARD_ID,
    EVENT_PLANNING_TEMPLATE_BOARD_ID,
    FINANCIAL_BOARD_TEMPLATE_BOARD_ID,
    HADI_CYCLE_TEMPLATE_BOARD_ID,
    HIRING_PROCESS_TEMPLATE_BOARD_ID,
    IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID,
    KANBAN_PRIORITIES_TEMPLATE_BOARD_ID,
    LESSON_PLANNING_TEMPLATE_BOARD_ID,
    MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID,
    MVP_CREATION_TEMPLATE_BOARD_ID,
    MY_FIRST_TEMPLATE_BOARD_ID,
    PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID,
    PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID,
    SALES_PIPELINE_TEMPLATE_BOARD_ID,
    SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID,
    THINGS_CONCEPT_TEMPLATE_BOARD_ID,
    UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID,
    VIDEO_CREATION_TEMPLATE_BOARD_ID,
    WEEKLY_PLANNING_TEMPLATE_BOARD_ID
} from '../../../const';
import { loadTemplates } from 'app/view/react_components/dialogs/openBoards/effects/loadTemplates';
import { getTemplatesIdsByType } from 'app/view/react_components/dialogs/openBoards/store/templates/selectors/getTemplatesIdsByType';
import { ETemplateType } from 'app/view/react_components/dialogs/openBoards/store/templates/types';
import { dispatch, getAppState } from 'app/store/configureStore';

export const firstBoardPrepareAllFirstBoards = (
) => {
    firstBoardLoadAndSave(root.Settings.firstBoardIdMicrosoft)
        .then(console.log);
    firstBoardLoadAndSave(root.Settings.firstBoardPwcId)
        .then(console.log);
    firstBoardLoadAndSave(root.Settings.firstBoardId)
        .then(console.log);
    firstBoardLoadAndSave(root.Settings.tipsAndTricksBoardIdMicrosoft)
        .then(console.log);
    firstBoardLoadAndSave(root.Settings.tipsAndTricksBoardId)
        .then(console.log);

    firstBoardLoadAndSave(MY_FIRST_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(MARKETING_ACTIVITIES_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(HADI_CYCLE_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(HIRING_PROCESS_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(PRODUCT_DEVELOPMENT_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(SALES_PIPELINE_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(COMPANY_GOALS_WORKFLOW_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(DESIGN_PROCESS_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(CUSTOMER_SUPPORT_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(FINANCIAL_BOARD_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(UIUX_DESIGN_WORKFLOW_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(CONTENT_CREATION_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(IT_DEVELOPMENT_SPRINTS_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(EVENT_PLANNING_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(VIDEO_CREATION_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(THINGS_CONCEPT_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(SMALL_TEAMS_COLLABORATION_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(BUSINESS_CANVAS_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(KANBAN_PRIORITIES_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(WEEKLY_PLANNING_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(MVP_CREATION_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(CLASSIC_KANBAN_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(AGILE_DEVELOPMENT_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(PROJECT_MANAGEMENT_TEMPLATE_BOARD_ID).then(console.log);

//edu
    firstBoardLoadAndSave(LESSON_PLANNING_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(CLASSROOM_NEWSLETTER_TEMPLATE_BOARD_ID).then(console.log);
    firstBoardLoadAndSave(CLASSROOM_WORK_TEMPLATE_BOARD_ID).then(console.log);

    //blank
    firstBoardLoadAndSave(BLANK_TEMPLATE_BOARD_ID).then(console.log);

    dispatch(loadTemplates()).then(() => {
        const promises = [...getTemplatesIdsByType(getAppState(), ETemplateType.default), ...getTemplatesIdsByType(getAppState(), ETemplateType.edu)]
            .map(templateId => firstBoardLoadAndSave(templateId).then(console.log));
        return Promise.all(promises);
    });

    dispatch(loadTemplates(true)).then(() => {
        const promises = [...getTemplatesIdsByType(getAppState(), ETemplateType.nuser)]
            .map(templateId => firstBoardLoadAndSave(templateId).then(console.log));
        return Promise.all(promises);
    });
};
